'use client'

import {
  formatPhoneDisplay,
  normalizePhoneDigits,
} from '@ui/components/forms/masks/phone'
import { Input } from '@ui/components/shadcn/ui/input'

import { BaseFieldProps, FieldShell } from './FieldShell'

// Form state holds the raw 10 digits; only the display is formatted.
export function PhoneField({
  label = 'Mobile number',
  locked,
  ...shell
}: Omit<BaseFieldProps, 'label'> & {
  label?: BaseFieldProps['label']
  locked?: boolean
}) {
  return (
    <FieldShell<string> label={label} {...shell}>
      {({ field, controlProps }) => (
        <Input
          {...controlProps}
          type="tel"
          inputMode="tel"
          autoComplete="tel-national"
          readOnly={locked}
          className={locked ? 'bg-muted text-muted-foreground' : undefined}
          value={formatPhoneDisplay(field.state.value)}
          onChange={(event) =>
            field.handleChange(normalizePhoneDigits(event.target.value))
          }
          onBlur={field.handleBlur}
        />
      )}
    </FieldShell>
  )
}
